<template>
  <v-container grid-list-xl text-xs-center>
    <v-layout fluid row wrap>
      <v-flex
        v-if="
          $store.state.userDetails.role == 'SuperAdmin' || $store.state.userDetails.role == 'Admin'
        "
        xs12
        md12
      >
        <v-card>
          <v-card-title>
            Send Broadcast Message
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                Send To
                <v-radio-group v-model="messageMode" :mandatory="false">
                  <v-radio label="One" value="user"></v-radio>
                  <v-radio label="Multiple" value="filter"></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex v-if="messageMode == 'user'" xs12>
                <v-select
                  v-model="selectedUserId"
                  :items="userList"
                  @change="selectedUser()"
                  item-text="name"
                  item-value="id"
                  label="Select User"
                ></v-select>
              </v-flex>

              <v-flex v-else xs12>
                <user-filter ref="userFilter"></user-filter>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field v-model="subject" label="Subject" type="text" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-textarea v-model="message" name="Message" label="Message"></v-textarea>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-row justify="center" style="padding-bottom: 4%;">
                  <v-btn
                    @click.native="broadCastMessage"
                    color="green"
                    class="white--text"
                  >Broadcast</v-btn>
                </v-row>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout fluid row wrap>
      <v-flex xs12 md6>
        <v-card>
          <v-card-title>
            Unseen
            <v-spacer></v-spacer>
            <v-btn @click="sortUnseenAsc = !sortUnseenAsc">
              <v-icon>filter_list</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-list avatar two-line>
            <div v-for="item in unseen" :key="item.id">
              <v-list-item>
                <v-list-item-avatar :color="item.seen ? 'green' : 'red'">
                  <span v-if="item.context == 'covidAlert'" small dark>🦠</span>
                  <span v-else>
                    <v-icon dark>notifications</v-icon>
                  </span>
                </v-list-item-avatar>

                <v-list-item-content @click="handleClick(item)">
                  {{ item.message }}
                  <small color="grey lighten-1">{{ ago(item.createdOn) }}</small>
                </v-list-item-content>

                <v-list-item-action @click="setSeen(item, true)">
                  <v-icon color="grey lighten-1">visibility</v-icon>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card>
          <v-card-title>
            Seen
            <v-spacer></v-spacer>
            <v-btn @click="sortSeenAsc = !sortSeenAsc">
              <v-icon>filter_list</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-list two-line>
            <div v-for="item in seen" :key="item.id">
              <v-list-item>
                <v-list-item-avatar :color="item.seen ? 'green' : 'red'">
                  <span v-if="item.context == 'covidAlert'" small dark>🦠</span>
                  <span v-else>
                    <v-icon dark>notifications</v-icon>
                  </span>
                </v-list-item-avatar>

                <v-list-item-content @click="handleClick(item)">
                  {{ item.message }}
                  <small color="grey lighten-1">{{ ago(item.createdOn) }}</small>
                </v-list-item-content>

                <v-list-item-action @click="setSeen(item, false)">
                  <v-icon color="yellow lighten-1">visibility_off</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import blob from "blob";
import Papa from "papaparse";
import { mapState } from "vuex";
//import DatePicker from "vue2-datepicker";
import moment from "moment-timezone";
import { isMobile } from "mobile-device-detect";
//import { Datetime } from "vue-datetime";
import { EventBus } from "@/utilities/event-bus.js";
//import "vue-datetime/dist/vue-datetime.css";
import VNodata from "@/components/Unavailable/nodata.vue";
import huddle from "@/utilities/huddle";
moment.fn.fromNowOrNow = function(a) {
  if (Math.abs(moment().diff(this)) < 25000) {
    // 25 seconds before or after now
    return "just now";
  }
  return this.fromNow(a);
};

export default {
  data: () => ({
    messageMode: "user",
    sortSeenAsc: true,
    sortUnseenAsc: true,
    userList: [],
    selectedUserId: "",
    showFilter: false,
    filtersApplied: false,
    subject: "",
    message: "",
    selectedTags: {},
    unsub: () => {}
  }),
  computed: {
    unseen() {
      if (this.sortUnseenAsc) {
        return _.sortBy(
          _.filter(this.$store.getters.notifications, d => {
            return d.seen == false;
          }),
          n => {
            return moment(n.time).toDate();
          }
        );
      } else {
        return _.sortBy(
          _.filter(this.$store.getters.notifications, d => {
            return d.seen == false;
          }),
          n => {
            return moment(n.time).toDate();
          }
        ).reverse();
      }
    },

    seen() {
      if (this.sortSeenAsc) {
        return _.sortBy(
          _.filter(this.$store.getters.notifications, d => {
            return d.seen == true;
          }),
          n => {
            return moment(n.time).toDate();
          }
        );
      } else {
        return _.sortBy(
          _.filter(this.$store.getters.notifications, d => {
            return d.seen == true;
          }),
          n => {
            return moment(n.time).toDate();
          }
        ).reverse();
      }
    }
  },
  created() {
    var self = this;

    self.selectedUserList();

    self.unsub = self.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "setSelectedTags" ||
        mutation.type === "setMode" ||
        mutation.type === "setGroup"
      ) {
        const opts = {
          tags: _.map(
            _.filter(state.selectedTags, t => t.type == "tag"),
            "id"
          ),
          locations: _.map(
            _.filter(state.selectedTags, t => t.type == "location"),
            "id"
          ),
          mode: state.mode,
          group: state.group
        };
        self.selectedTags = opts;
      }
    });

    self.updateTagAndLocation(this.$store.getters.getSelectedTagsAndLocations);
  },
  methods: {
    updateTagAndLocation(tags) {
      // this.setLoading = true
      const self = this;

      if (typeof tags !== "undefined") self.selectedTags = tags;
      if (typeof tags !== "undefined" && tags.hasOwnProperty("locations"))
        this.selectedTags = tags;
    },

    selectedUser() {
      var self = this;
      self.showFilter = false;
    },

    broadCastMessage() {
      var self = this;
      var filterData = {};

      if (self.subject == "") {
        self.$swal({ type: "warning", text: "Subject can not be blank" });
        return;
      }

      if (self.message == "") {
        self.$swal({ type: "warning", text: "Message can not be blank" });
        return;
      }

      filterData = {
        tags: self.selectedTags.tags,
        locations: self.selectedTags.locations,
        groupId: self.selectedTags.group,
        mode: self.selectedTags.mode
      };

      self.$http
        .post(`${self.$store.state.endpoint}notifications/sendbroadcast`, {
          mode: self.messageMode,
          toId: self.selectedUserId,
          subject: self.subject,
          message: self.message,
          filter: filterData
        })
        .then(res => {
          console.log("response from server", res.body);
          self.$swal({
            type: "success",
            text: "Notification sent successfully"
          });
        })
        .catch(err => {
          self.$swal({ type: "error", text: "Something went wrong" });
        });
    },
    selectedUserList() {
      const self = this;

      this.$http
        .post(`${this.$store.state.endpoint}Accounts/byFilter`, {
          groupId: "all",
          mode: "OR"
        })
        .then(
          response => {
            var response = response.body;

            self.userList = [];

            for (const m in response) {
              response[
                m
              ].name = `${response[m].firstName} ${response[m].lastName}`;
              self.userList.push(response[m]);
            }
          },
          error => {
            this.$swal({ type: "error", text: error.body.error.message });
          }
        );
    },

    ago(time) {
      return moment(time).fromNowOrNow();
    },
    async setSeen(item, status) {
      try {
        await this.$http.patch(
          `${this.$store.state.endpoint}notifications/${item.id}`,
          {
            seen: status,
            seenOn: new Date()
          }
        );

        this.$store.dispatch("getNotifications");
      } catch (e) {
        console.log(e);
        this.$store.dispatch("getNotifications");
      }
    },
    async handleClick(item) {
      // Unseen
      try {
        await this.$http.patch(
          `${this.$store.state.endpoint}notifications/${item.id}`,
          {
            seen: true,
            seenOn: new Date()
          }
        );

        this.$store.dispatch("getNotifications");

        // Redirect to action
        if (item.action == "opentimesheet") {
          this.$parent.$router.push({
            name: "Timesheet Edit",
            params: { attendanceId: item.href }
          });
        }
        if (item.action == "close") {
        }

        if (item.action == "starthuddle") {
          huddle.start(
            item.data.url,
            item.data.room,
            this.$store.state.userDetails.firstName,
            this.$store.state.userDetails.email
          );
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch("getNotifications");
      }
    }
  }
};
</script>

<style scoped>
.v-list__tile__title,
.v-list__tile__sub-title {
  word-wrap: break-word !important;
  white-space: normal !important;
  overflow: initial !important;
}
</style>
